import {batch} from '../../helpers/reduxHelpers';
import {ActivityVisualTypesEnum} from '../../models/api/activityModel';
import {ApiMessageDataGroup} from '../../models/api/dataGroupModel';
import {MessageVisualStatusesEnum} from '../../models/api/messageModel';
import {ThunkAction} from '../../store/appThunk';
import {updateDataAction} from '../../store/data/dataGroupsActions';
import {postApiAsync} from '../http/http';
import {findActivityQueue} from './specializedTaskQueues';

// TODO: remove this file and use `deleteActivityTask` whenever it's actually possible to use it on a message (not yet implemented server-side)
export function destroyMessageTask(activityId: number): ThunkAction {
  return async (dispatch, getState) => {
    // Find the activity to delete.
    const activityQueue = findActivityQueue(dispatch, getState, activityId);

    const activity = activityQueue.get();
    if (!activity || activity.visualType !== ActivityVisualTypesEnum.MESSAGE) {
      return;
    }

    // Get the corresponding message (we need its URL).
    const {messages} = getState().data;
    const message = messages[activity.messageUid];
    if (!message || message.visualStatus === MessageVisualStatusesEnum.PARTIAL) {
      return;
    }

    // Delete instantly from the store.
    activityQueue.delete();

    await activityQueue.waitForTurnAsync();
    try {
      // Perform the request.
      const serverDataGroup = await postApiAsync(
        ApiMessageDataGroup,
        `${message.messageUrl}/destroy?include_conversation=true`,
        {},
      );

      batch(() => {
        dispatch(updateDataAction(serverDataGroup));
        activityQueue.reportDeleted();
      });
    } catch (error) {
      activityQueue.reportError();
      throw error;
    }
  };
}
